import { render } from "./HeaderPager.vue?vue&type=template&id=3cc45285&scoped=true"
import script from "./HeaderPager.vue?vue&type=script&lang=js"
export * from "./HeaderPager.vue?vue&type=script&lang=js"

import "./HeaderPager.vue?vue&type=style&index=0&id=3cc45285&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc45285"]])

export default __exports__